/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { JobSpecTemplateRestService } from '@gh/builder-shared-data';
import { FinderDialogConfig } from '@gh/common-internal-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import {
  JobSpecTemplateFinderFilter,
  JobSpecTemplateFinderListItem,
} from './job-spec-template-finder-list-item.model';

export interface JobSpecTemplateFinderDialogConfig extends FinderDialogConfig {
  sourceOfficeId?: ID;
  filter?: Partial<JobSpecTemplateFinderFilter>;
}

@Injectable()
export class JobSpecTemplateFinderBusinessService {
  constructor(private restService: JobSpecTemplateRestService) {
  }

  findAllAsDataSource(filter: JobSpecTemplateFinderFilter): SlicedDataSource<JobSpecTemplateFinderListItem> {
    return this.restService.findAllAsDataSource(filter);
  }
}
